// 바바리안 동료 클래스 - 근접 공격을 사용하는 전사 동료 (Companion 상속)
class BarbarianCompanion extends Companion {
  constructor(scene, player, config) {
    super(scene, player, config, "BARBARIAN");
  }

  // 애니메이션 인덱스 정의 (부모 클래스 메서드 오버라이드)
  getAnimationIndices() {
    return {
      idle: 36, // 대기 애니메이션
      move: 49, // 걷기 애니메이션
      aim: null, // 조준 애니메이션
      attack: 10, // 공격 애니메이션
      hit: 34, // 피격 애니메이션
      death: 23, // 죽음 애니메이션
    };
  }

  // Barbarian 무기와 장비 숨기기 (부모 클래스 메서드 오버라이드)
  hideWeapons() {
    if (!this.model) return;

    this.model.traverse((child) => {
      if (child.isMesh) {
        const childName = child.name ? child.name.toLowerCase() : "";

        // 모든 도끼와 방패 숨기기
        if (
          childName === "1h_axe" ||
          childName === "barbarian_round_shield" ||
          childName === "mug"
        ) {
          child.visible = false;
          Utils.log(`Barbarian 무기 숨김: ${child.name}`);
        }
      }
    });
  }

  // AI 상태 머신 - 바바리안은 aimDistance가 10배
  updateAI(deltaTime, enemies) {
    // 강제 idle 상태면 AI 업데이트 하지 않음 (게임오버 시 앉기 애니메이션 유지)
    if (this.isForcedIdle) return;

    const playerDistance = this.getDistanceToPlayer();
    const nearestEnemy = this.findNearestEnemy(enemies);
    const enemyDistance = nearestEnemy
      ? this.getDistanceToEnemy(nearestEnemy)
      : Infinity;
    const aimDistance = this.attackDistance * 10; // 바바리안은 10배!

    // 상태별 핸들러 실행
    const context = {
      nearestEnemy,
      enemyDistance,
      playerDistance,
      aimDistance,
      deltaTime,
    };
    const handlers = {
      FOLLOW: this.handleFollowState.bind(this),
      AIM: this.handleAimState.bind(this),
      ATTACK: this.handleAttackState.bind(this),
      IDLE: this.handleIdleState.bind(this),
    };

    const handler = handlers[this.currentState];
    if (handler) handler(context);
  }

  // AIM 상태 처리 - 바바리안은 적에게 달려간다!
  handleAimState({ nearestEnemy, enemyDistance, aimDistance }) {
    if (!nearestEnemy || enemyDistance > aimDistance) {
      this.transitionToFollow();
    } else if (enemyDistance <= this.attackDistance) {
      this.transitionToAttack(nearestEnemy);
    } else {
      // 적을 향해 이동하면서 바라봄
      this.moveTowardsEnemy(nearestEnemy);
      this.playAnimation("run");
    }
  }

  // 적을 향해 이동 (바바리안 전용)
  moveTowardsEnemy(enemy) {
    if (!enemy) return;

    const distance = this.getDistanceToEntity(enemy);

    // 적과의 최소 거리 유지 (겹침 방지)
    const minDistance =
      this.colliderRadius + (enemy.colliderRadius || 0.5) + 0.2;

    if (distance > minDistance) {
      // 방향 벡터 계산
      const direction = new THREE.Vector3()
        .subVectors(enemy.position, this.position)
        .normalize();
      // 적 방향으로 회전
      this.lookAtDirection(direction);

      // 새로운 위치 계산 (멤버 변수 사용)
      const moveVector = direction.multiplyScalar(this.moveSpeed);
      const newPosition = new THREE.Vector3()
        .copy(this.position)
        .add(moveVector);

      // 위치 업데이트
      this.updatePosition(newPosition);
    }
  }
}

// 전역으로 내보내기
if (typeof module !== "undefined" && module.exports) {
  module.exports = BarbarianCompanion;
} else {
  window.BarbarianCompanion = BarbarianCompanion;
}

// webpack 빌드를 위해 default export 추가
export default BarbarianCompanion;
